import { render } from "./InitiativeTurn.vue?vue&type=template&id=38f6c348&scoped=true&bindings={}"
import script from "./InitiativeTurn.vue?vue&type=script&lang=ts"
export * from "./InitiativeTurn.vue?vue&type=script&lang=ts"

import "./InitiativeTurn.vue?vue&type=style&index=0&id=38f6c348&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38f6c348"

export default script